import { _, allRoles, isAuthorized, lazyLoadView, piloteAndAuditor, requiresInternal, setNavL2 } from '@/router/routing'
import type { Route, RouteConfig } from 'vue-router'
import {
  RUNBOOKS_ROUTE_NAME,
  RUNTASKS_ROUTE_NAME,
  RUNBOOK_LABEL_ROUTE_NAME,
} from '@/contexts/recurring-tasks/RecurringTasks.constants'

export const recurringTasksRoutes: RouteConfig = {
  path: '/runbooks',
  name: RUNBOOKS_ROUTE_NAME,
  component: () => lazyLoadView(import('@/contexts/recurring-tasks/RunbooksListView.vue')),
  meta: {
    title: _('Recurring tasks'),
    icon: 'clipboard-check',
    is_authorized: (route: Route) => isAuthorized(route),
    requires_auth: true,
    requires_tenant: true,
    requires_role: piloteAndAuditor,
    hidden_for_fp_assessment: true,
    doc_id: 'runbook',
    feature_id: 'RUNTASKS',
  },
  children: [
    {
      path: ':id',
      name: RUNTASKS_ROUTE_NAME,
      component: () => lazyLoadView(import('@/contexts/recurring-tasks/RunbookView.vue')),
      meta: {
        title: null,
        icon: 'clipboard-check',
        is_authorized: (route: Route) => isAuthorized(route),
        hidden_for_fp_assessment: true,
        requires_auth: true,
        requires_tenant: true,
        requires_role: piloteAndAuditor,
        doc_id: 'my_runtasks',
      },
    },
    {
      path: 'label/list',
      name: RUNBOOK_LABEL_ROUTE_NAME,
      component: () => lazyLoadView(import('@/contexts/recurring-tasks/RunbookView.vue')),
      meta: {
        title: null,
        icon: 'clipboard-check',
        is_authorized: (route: Route) => isAuthorized(route),
        hidden_for_fp_assessment: true,
        requires_auth: true,
        requires_tenant: true,
        requires_role: piloteAndAuditor,
        doc_id: 'my_runtasks',
      },
    },
  ],
}

export const recurringTasksContributionRoutes: RouteConfig = {
  path: 'runtasks',
  name: 'glrunbook',
  component: () => lazyLoadView(import('@/contexts/recurring-tasks/RunbookView.vue')),
  beforeEnter: setNavL2,
  meta: {
    title: _('Recurring tasks'),
    icon: 'clipboard-check',
    is_authorized: (route: Route) => isAuthorized(route),
    requires_auth: true,
    requires_tenant: true,
    requires_role: allRoles,
    requires_internal: () => requiresInternal(),
    hidden_for_fp_assessment: true,
    doc_id: 'my_runtasks',
    nb_contribution: 'nb_runtasks',
  },
}
